import { render, staticRenderFns } from "./VendasEmpresas.vue?vue&type=template&id=2d291bce&scoped=true"
import script from "./VendasEmpresas.vue?vue&type=script&lang=js"
export * from "./VendasEmpresas.vue?vue&type=script&lang=js"
import style0 from "./VendasEmpresas.vue?vue&type=style&index=0&id=2d291bce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d291bce",
  null
  
)

export default component.exports